module.exports = __webpack_public_path__ + "media/images/basic_logos/bargraph-c3c822f113dde931b6ddeca1f67e9c56.png";